import { z } from 'zod'

export const PerkSortKeySchema = z.enum([
  'category',
  'description',
  'discount',
  'name',
  'offer',
  'type',
])

export const PerkSortKey = PerkSortKeySchema.enum

export type PerkSortKey = z.infer<typeof PerkSortKeySchema>
